import { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const EMPTY_HTML = '<p><br></p>';

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link'],
  ['clean'],
];

function normalizeHtml(html) {
  if (!html || html === EMPTY_HTML) {
    return '';
  }
  return html;
}

/**
 * 基於 Quill 的富文本編輯器（不依賴 react-quill，相容 React 19）。
 * 僅在掛載時寫入初始內容，避免受控同步破壞 Quill 內部狀態。
 */
export default function RichTextEditor({ value, onChange, placeholder }) {
  const containerRef = useRef(null);
  const quillRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return undefined;
    }

    const editorEl = document.createElement('div');
    container.appendChild(editorEl);

    const quill = new Quill(editorEl, {
      theme: 'snow',
      modules: { toolbar: TOOLBAR },
      placeholder: placeholder || '',
    });
    quillRef.current = quill;
    quill.clipboard.dangerouslyPasteHTML(value || '');

    const handleChange = () => {
      onChangeRef.current?.(normalizeHtml(quill.root.innerHTML));
    };
    quill.on('text-change', handleChange);

    return () => {
      quill.off('text-change', handleChange);
      quill.disable();
      quillRef.current = null;
      container.innerHTML = '';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="rich-text-editor" ref={containerRef} />;
}
